<div class="btn-group">
  <a class="btn dropdown dropdown-toggle d-flex align-items-center" href="javascript:;" data-toggle="dropdown"
    aria-haspopup="true" aria-expanded="false">
    <div class="ml-1 mr-1">
      @if (user()) {
        <span class="float-left">{{user() | personName}}</span> <br />
        <span class="float-left">{{user()?.userProfile?.currentProfileName}}</span>
      }
    </div>
  </a>
  <div class="dropdown-menu">
    <ul class="pl-0">
      @if (switchToRole()) {
        <li class="dropdown-item">
          <a class="nav-link text-dark" href="javascript:;" (click)="onSwitchProfile()">
            Switch to {{switchToRole()}}
          </a>
        </li>
      }
      @if (showReturnToMain()) {
        <li class="dropdown-item">
          <a class="nav-link text-dark" href="javascript:;" (click)="returnToMainAccount()">
            Return to Main Account
          </a>
        </li>
      }
      <li class="dropdown-item">
        <a class="nav-link text-dark" [routerLink]="['/account']">Account Info</a>
      </li>
      @if (showManagements()) {
        <li class="dropdown-item">
          <a class="nav-link text-dark" [routerLink]="['/managements']">Managements</a>
        </li>
      }
      <li class="dropdown-item">
        <a class="nav-link text-dark"
          href="https://sites.google.com/securechoicelending.com/scl-internal-hq/secure-choice-lending/company-holidays?authuser=1"
        target="_blank">Corporate Events/Holidays</a>
      </li>
      <li class="dropdown-item">
        <a class="nav-link text-dark" href="http://internal.sclportal.com/" target="_blank">Internal HQ</a>
      </li>
      <li class="dropdown-item">
        <a class="nav-link text-dark"  [routerLink]="['/marketing/flyers']" >Flyers</a>
      </li>
      <li class="dropdown-item">
        <a class="nav-link text-dark"  [routerLink]="['/marketing/graphics']" >Graphics</a>
      </li>
      <li class="dropdown-item">
        <a class="nav-link text-dark"  [routerLink]="['/crm/campaigns']" >CRM</a>
      </li>
      <!--<li class="dropdown-item">
      <a class="nav-link text-dark" [routerLink]="[]">Reset Password</a>
    </li>-->
    <li class="dropdown-item">
      <a class="nav-link text-dark" href="javascript:;" (click)="logout()">Logout</a>
    </li>
  </ul>
</div>
</div>